import { all, fork, put, takeEvery } from 'redux-saga/effects';
import { mediumFetchError, mediumFetchSuccess } from './actions';
import MediumService from '../../services/mediums';

const service = new MediumService();

function* handleFetch(payload) {
  try {
    const data = yield service.getList(payload.payload);

    yield put(mediumFetchSuccess(data));
  } catch (err) {
    if (err instanceof Error && err.stack) {
      yield put(mediumFetchError(err.stack));
    } else {
      yield put(mediumFetchError('An unknown error occured.'));
    }
  }
}

function* watchFetchRequest() {
  yield takeEvery('mediumFetchAction', handleFetch);
}

function* mediumSaga() {
  yield all([fork(watchFetchRequest)]);
}

export default mediumSaga;